<template>
  <div>
    <el-card class="box-card">
      <div class="title">Добро пожаловать!</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data: function () {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 550px;
  margin: 50px auto;
  padding: 15px 15px 1px 15px;
  box-shadow: 0 0 51px 0 #efefef;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #ececec;
}

.title {
  margin-bottom: 10px;
}
</style>
